import { fetchWrapper } from "./fetch-wrapper";
import toast from "react-hot-toast";

class Api {
  createResponse = (uri, params = {}) => {
    return new Promise(async (resolve, reject) => {
      let toastId;
      if (!params.withoutLoading) {
        toastId = toast.loading("Cargando...");
      }

      try {
        const url = `${process.env.REACT_APP_BASE_API}${uri}`;
        const res = params.hasFile
          ? await fetchWrapper.upload(url, params)
          : await fetchWrapper.post(url, params);

        if (!params.withoutLoading) toast.dismiss(toastId);
        resolve(res);
      } catch (err) {
        if (!params.withoutLoading) toast.dismiss(toastId);
        reject(err);
      }
    });
  };
}

const apiInstance = new Api();
export default apiInstance;
